import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import CheckCircleWhiteFilled from './CheckCircleWhiteFilled';

function HeroCheckBullet({ size = 24, sx, ...props }) {
  const theme = useTheme();
  const green =
    theme.palette?.primary?.success != null
      ? theme.vars.palette.primary.success
      : '#43A047';

  return (
    <CheckCircleWhiteFilled
      aria-hidden
      sx={{
        fontSize: size,
        color: green,
        display: 'block',
        ...sx,
      }}
      {...props}
    />
  );
}

HeroCheckBullet.propTypes = {
  size: PropTypes.number,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
};

export default HeroCheckBullet;
